import styled from 'styled-components';
import { Close } from '@styled-icons/ionicons-solid';

export const PopupWrapper = styled.div`
  position: fixed;
  z-index: 1000;
  top: 0;
  left: 0;
  background-color: #f4f4f2;
  width: 100%;
  height: 100%;
`;

export const PopupHeader = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: right;
  width: 100%;
  min-height: 60px;
  height: 10%;
`;

export const PopupBody = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: right;
  width: 80%;
  height: 100%;
  overflow: scroll;
  margin: auto;
`;

export const PopupFooter = styled.div`
  display: inline-block;
  position: fixed;
  bottom: 0;
  height: 80px;
  width: 100%;
  background-color: #003d50;
`;

export const HeaderTitle = styled.h1`
  display: flex;
  flex-direction: row;
  justify-content: center;
  width: 100%;
  text-align: center;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 40px 160px 40px;
`;

export const CloseButton = styled.button`
  display: inline-grid;
  border: none;
  background: inherit;
  padding: 30px;
`;

export const CloseIcon = styled(Close)`
  color: black;
`;

export const CloseText = styled.div`
  text-align: center;
`;

export const ActionSection  = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 80%;
  margin: 0px 40px 0px 40px;
`;

export const ButtonSection = styled.div`
  display: flex;
  justify-content: flex-end;
`;

export const ActionButton = styled.button`
  background-color: white;
  border: 1px solid #20907f;
  color: #20907f;
  font-weight: bold;
  width: 110px;
  max-width: 110px;
  border-radius: 25px;
  padding: 8px;
  margin: 10px;
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  &:hover {
    cursor: pointer;
    background-color: #20907f;
    color: white;
  }
  &:disabled {
    background-color: #ccc;
    border: 1px solid #ccc;
    color: white;
    cursor: default;
  }
`;